import { render, staticRenderFns } from "./RelationsEChartsTester.vue?vue&type=template&id=16d5c932"
import script from "./RelationsEChartsTester.vue?vue&type=script&lang=js"
export * from "./RelationsEChartsTester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports